export default __webpack_public_path__ + "static/media/pictogramBeaconCarbonTrees48.65b830ae.svg";